import React from 'react';
import { DatabaseIcon, MailIcon, PhoneIcon, CheckCircleIcon } from 'lucide-react';
export function SequencePricing() {
  return <section className="py-24 bg-slate-50" data-id="element-1572">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1573">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-1574">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6 leading-tight" data-id="element-1575">
            Simple pricing for{' '}
            <span className="text-blue-600" data-id="element-1576">email sequence software</span>
          </h2>
          <p className="text-xl text-slate-600 leading-relaxed" data-id="element-1577">
            Launch B2B email sequences without enterprise contracts or hidden
            per-seat fees.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-1578">
          {/* Search Businesses */}
          <div className="bg-white border border-slate-200 rounded-xl p-8 flex flex-col" data-id="element-1579">
            <div className="flex items-center gap-3 mb-4" data-id="element-1580">
              <DatabaseIcon className="w-5 h-5 text-slate-400" data-id="element-1581" />
              <h3 className="text-lg font-bold text-slate-900" data-id="element-1582">
                Search local businesses
              </h3>
            </div>
            <p className="text-slate-600 mb-8 flex-grow" data-id="element-1583">
              Search and filter our database of 200M+ local businesses to build
              your prospect list.
            </p>
            <div data-id="element-1584">
              <div className="flex items-baseline gap-2" data-id="element-1585">
                <span className="text-4xl font-bold text-slate-900" data-id="element-1586">Free</span>
              </div>
              <p className="text-sm text-slate-500 mt-1" data-id="element-1587">unlimited searches</p>
            </div>
          </div>

          {/* Owner Emails */}
          <div className="bg-white border border-slate-200 rounded-xl p-8 flex flex-col" data-id="element-1588">
            <div className="flex items-center gap-3 mb-4" data-id="element-1589">
              <MailIcon className="w-5 h-5 text-slate-400" data-id="element-1590" />
              <h3 className="text-lg font-bold text-slate-900" data-id="element-1591">
                Owner emails for outreach
              </h3>
            </div>
            <p className="text-slate-600 mb-8 flex-grow" data-id="element-1592">
              Get verified email addresses to launch your automated email
              sequences.
            </p>
            <div data-id="element-1593">
              <div className="flex items-baseline gap-2" data-id="element-1594">
                <span className="text-4xl font-bold text-slate-900" data-id="element-1595">$6</span>
              </div>
              <p className="text-sm text-slate-500 mt-1" data-id="element-1596">
                per 100 emails found
              </p>
            </div>
          </div>

          {/* Employee Phones */}
          <div className="bg-white border border-slate-200 rounded-xl p-8 flex flex-col" data-id="element-1597">
            <div className="flex items-center gap-3 mb-4" data-id="element-1598">
              <PhoneIcon className="w-5 h-5 text-slate-400" data-id="element-1599" />
              <h3 className="text-lg font-bold text-slate-900" data-id="element-1600">
                Direct phone numbers
              </h3>
            </div>
            <p className="text-slate-600 mb-8 flex-grow" data-id="element-1601">
              Access direct dials for multi-channel CRM sequences emails calls.
            </p>
            <div data-id="element-1602">
              <div className="flex items-baseline gap-2" data-id="element-1603">
                <span className="text-4xl font-bold text-slate-900" data-id="element-1604">$24</span>
              </div>
              <p className="text-sm text-slate-500 mt-1" data-id="element-1605">
                per 100 phones found
              </p>
            </div>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-12 mb-16" data-id="element-1606">
          <div className="flex items-center gap-2 text-slate-600 font-medium" data-id="element-1607">
            <CheckCircleIcon className="w-5 h-5 text-slate-400" data-id="element-1608" />
            <span data-id="element-1609">Pay only for valid results</span>
          </div>
          <div className="flex items-center gap-2 text-slate-600 font-medium" data-id="element-1610">
            <CheckCircleIcon className="w-5 h-5 text-slate-400" data-id="element-1611" />
            <span data-id="element-1612">Free credits to start</span>
          </div>
          <div className="flex items-center gap-2 text-slate-600 font-medium" data-id="element-1613">
            <CheckCircleIcon className="w-5 h-5 text-slate-400" data-id="element-1614" />
            <span data-id="element-1615">No credit card required</span>
          </div>
        </div>

        <div className="text-center" data-id="element-1616">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-4" data-id="element-1617">
            <a href="http://app.openmart.com/register" target="_blank" rel="noopener noreferrer" className="inline-block px-10 py-4 text-white font-bold bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors text-lg" data-id="element-1618">
              Try for free
            </a>
          </div>
        </div>
      </div>
    </section>;
}